// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './axios'
import './assets/js/cookie'

// 时间格式化插件
import moment from 'moment'
Vue.prototype.moment = moment

import '@/icons' //  全局注册组件

import 'vant/lib/index.css';
import { Button, Grid, GridItem, NavBar, Image as VanImage, Cell, CellGroup, Col, Row, Field, Area, Toast, Checkbox, CheckboxGroup, Tabbar, TabbarItem, Loading, RadioGroup, Radio,
  DatetimePicker, Picker, Empty, List, PullRefresh, Search, Tab, Tabs, Divider, Sticky, Switch, Popup, Icon,Rate, Dialog, Form, TreeSelect, DropdownMenu, DropdownItem,Overlay, Swipe, SwipeItem  } from "vant";
Vue.use(Button)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(NavBar)
Vue.use(VanImage)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Col)
Vue.use(Row)
Vue.use(Field)
Vue.use(Area)
Vue.use(Toast)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Loading)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(DatetimePicker)
Vue.use(Picker)
Vue.use(Empty)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Search)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Divider)
Vue.use(Sticky)
Vue.use(Switch)
Vue.use(Popup)
Vue.use(Icon)
Vue.use(Rate)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(TreeSelect)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Overlay)
Vue.use(Swipe)
Vue.use(SwipeItem)

import PagetationList from './components/pagetation'
Vue.use(PagetationList)

import Footer from './components/footer'
Vue.use(Footer)

Vue.config.productionTip = false

import utils from './assets/js/utils'
Vue.prototype.utils = utils

import data from './assets/js/configure'
// 项目配置
Vue.prototype.fromData = data


router.beforeEach((to, from, next) => {
  if(!to.params.appid) {
    if (to.meta.title) {
      document.title = to.meta.title;
    } else {
      document.title = "政策一站享";
    }
  } else {
    document.title = "政策一站享";
  }

  let isLogin = window.localStorage.getItem("isToken");
  if (to.meta.requireAuth) {
    if (isLogin !== 'true') {
      next({
        path: '/Login',
        query: { redirect: to.fullPath }
      })
      return
    }
  }

  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js